export default "__VITE_ASSET__78fd99e0__"